import * as React from 'react';
import MainLayout from '../../components/Layout/Main';
import {Pages} from '../../interfaces';
import Intro from '../../components/Intro';
import LoginForm from '../../components/LoginForm';
import { useSelector } from 'react-redux';
import {IAppState} from '../../state'
import {IUser} from '../../interfaces';



export default function Home() {
    const user:{currentUser?: IUser | null, error?: any} = useSelector(({userReducer}: IAppState) => userReducer);
    
    return user.currentUser ? (
        <div>
            <MainLayout page={Pages.Intro}>
                <Intro preview={true} />
            </MainLayout>
        </div>
    ) :
        <div>
            <MainLayout page={Pages.Login}>
                <LoginForm />
            </MainLayout>
        </div>;
};
